import { render } from "./ProjectModulationComponent.vue?vue&type=template&id=1ffc9d68&scoped=true&ts=true"
import script from "./ProjectModulationComponent.vue?vue&type=script&lang=ts"
export * from "./ProjectModulationComponent.vue?vue&type=script&lang=ts"

import "./ProjectModulationComponent.vue?vue&type=style&index=0&id=1ffc9d68&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffc9d68"]])

export default __exports__